import React from 'react';
import _ from 'lodash';

import BaseComponent from '../../../../baseClasses/BaseComponent';
import LocationRow from './LocationRow';
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';
import scrollIcon from '../../../../assets/images/document-scroll-2.svg';
import TableHeader from '../../../../components/Table/TableHeader';
import TableRow from '../../../../components/Table/TableRow';
import { DOCUMENTS, CLOSEOUT_HISTORY, PROGRESS_REPORTS } from '../../../../constants/TabConstants';
import './AttachmentsTable.scss';

export default class AttachmentsTable extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectAll: {},
    };
    this.analyticsLogger = new AnalyticsLogger({
      isMobile: !!window.cordova,
    });
  }

  componentDidMount() {
   
  }

  componentDidUpdate(prevProps) {
    const { toggleSelected } = this.props;
    if (toggleSelected != prevProps.toggleSelected) {
      this.setState({ selectedProjects: {}, selectedAttachments: {}, selectedAttachment: null });  
    }
  }

  handleCheckAll(checked) {
    let viewing = this.props.viewing;
    let { selectAll, selectedLocationId } = this.state;
    if (this.props.locations) {
      this.props.locations.filter(location => {
        if (selectedLocationId && location.id != selectedLocationId) {
          return false;
        }
        if (!checked && this.state.locationsChecked && this.state.locationsChecked[viewing] && this.state.locationsChecked[viewing][location.id]) {
          delete this.state.locationsChecked[viewing][location.id];
        } else if (checked) {
          if (!this.state.locationsChecked) {
            this.state.locationsChecked = {};
          }
          if (!this.state.locationsChecked[viewing]) {
            this.state.locationsChecked[viewing] = {};
          }
          this.state.locationsChecked[viewing][location.id] = location;
        }
        let docs = (viewing == CLOSEOUT_HISTORY) ? location.all_closeouts : (viewing == PROGRESS_REPORTS) ? this.props.progressReports : location.documents;
        if (docs) {
          docs.filter(attachment => {
            if (
              !checked &&
              this.state.attachmentsChecked &&
              this.state.attachmentsChecked[viewing] &&
              this.state.attachmentsChecked[viewing][attachment.id]
            ) {
              delete this.state.attachmentsChecked[viewing][attachment.id];
            } else if (checked && !attachment.status) {
              if (!this.state.attachmentsChecked) {
                this.state.attachmentsChecked = {};
              }
              if (!this.state.attachmentsChecked[viewing]) {
                this.state.attachmentsChecked[viewing] = {};
              }
              this.state.attachmentsChecked[viewing][attachment.id] = location;
            }
            return true;
          });
        }
        return true;
      });
    }
    selectAll[viewing] = !selectAll[viewing];
    this.setState({
      selectAll: selectAll,
      selectionChanged: !this.state.selectionChanged,
    });
  }

  sortDocsAndSetFirstAttachment(location) {
    const { viewing, progressReports } = this.props;
    let completionDocs;
    if (viewing == DOCUMENTS) {
      completionDocs = location.documents.filter(cd => {
        return true;
      });
      completionDocs.sort((c1, c2) => {
        if (c1.created_at < c2.created_at) {
          return 1;
        } else if (c1.created_at > c2.created_at) {
          return -1;
        } else {
          return 0;
        }
      });
    }
    else if (viewing == CLOSEOUT_HISTORY) {
      // filter out in progress closeout history (for now)...
      completionDocs = location.all_closeouts.filter((cd) => { return !(cd.status == 1);});
      completionDocs.sort((c1, c2) => {
        if (c1.updated_at < c2.updated_at) {
          return 1;
        } else if (c1.updated_at > c2.updated_at) {
          return -1;
        } else {
          return 0;
        }
      });
    }
    else if (viewing == PROGRESS_REPORTS) {
      // filter out in progress reports and sort by created_at descending
      completionDocs = _.orderBy(
        _.reject(progressReports || [], { status: 'in_progress' }),
        ['created_at'],
        ['desc']
      );
    }
    if (!this.firstAttachment && !this.state.selectedAttachment) {
      this.firstAttachment = completionDocs ? completionDocs[0] : null;
      this.handleAttachmentSelected(this.firstAttachment, true);
    }
    return completionDocs || [];
  }

  handleSelectLocationAttachments(select, location, selectedLocations) {
    let viewing = this.props.viewing;
    let { selectedAttachments } = this.state;
    if (!selectedAttachments) {
      selectedAttachments = {};
    }
    let attachments = null;
    if (viewing == DOCUMENTS) {
      attachments = location.documents;
    }
    else if (viewing == PROGRESS_REPORTS) {
      attachments = this.props.progressReports;
    }
    else {
      attachments = location.all_closeouts;
    }
    if (attachments) {
      attachments.forEach(attachment => {
        if (!select && selectedAttachments[attachment.id]) {
          delete selectedAttachments[attachment.id];
        }
        else if (select) {
          selectedAttachments[attachment.id] = attachment;
        }
      });
      this.setState({ selectedAttachments });
      if (this.props.handleSelectForExport) {
        this.props.handleSelectForExport(selectedLocations, selectedAttachments);
      }
    }
  }

  handleMultiSelect(select, location) {
    let { selectedLocations } = this.state;
    if (location) {
      if (!selectedLocations) {
        selectedLocations = {};
      }
      if (!select && selectedLocations[location.id]) {
        delete selectedLocations[location.id];
      }
      else if (select) {
        selectedLocations[location.id] = location;
      }
      this.handleSelectLocationAttachments(select, location, selectedLocations);
      this.setState({ selectedLocations });
    }
  }

  handleChecked(attachment, checked) {
    let { selectedAttachments } = this.state;
    if (!selectedAttachments) {
      selectedAttachments = {};
    }
    if (!checked && selectedAttachments[attachment.id]) {
      delete selectedAttachments[attachment.id];
    }
    else if (checked) {
      selectedAttachments[attachment.id] = attachment;
    }
    this.setState({ selectedAttachments });
    if (this.props.handleSelectForExport) {
      this.props.handleSelectForExport(this.state.selectedLocations, selectedAttachments);
    }

  }

  handleAttachmentSelected(selectedAttachment, isSelected) {
    this.setState({ selectedAttachment });
    if (this.props.handleSelectAttachment) {
      this.props.handleSelectAttachment(selectedAttachment);
    }
  }
  
  handleSort(sortField, direction) {
    const ascending = direction == 'up';
    if (sortField != this.state.sortField || ascending != this.state.ascending) {
      this.setState({ sortField, ascending });
    }
  }

  createTableHeader(location) {
    // Create header

    const { viewing } = this.props;
    let caretTypes = [];
    if (viewing == DOCUMENTS) {
      caretTypes = [
        { type: 'name', headerName: 'DOCUMENT FILE NAME', first: true }, 
        { type: 'type', headerName: 'TYPE' }, 
        { type: 'user', headerName: 'UPLOADED BY' },
        { type: 'upload_updated_at', headerName: 'DATE UPLOADED' },
      ];
    }
    else if (viewing == PROGRESS_REPORTS) {
      caretTypes = [
        { type: 'name', headerName: 'REPORT FILE NAME', first: true }, 
        { type: 'type', headerName: 'TYPE' }, 
        { type: 'user', headerName: 'GENERATED BY' },
        { type: 'upload_updated_at', headerName: 'DATE GENERATED' },
      ];
    }
    else {
      caretTypes = [
        { type: 'name', headerName: 'CLOSEOUT FILE NAME', first: true }, 
        { type: 'closeoutable_type', headerName: 'CLOSEOUT TYPE' },
        { type: 'type', headerName: 'TYPE' }, 
        { type: 'user', headerName: 'USER' },
        { type: 'upload_updated_at', headerName: 'DATE GENERATED' },
      ];
    }

    const accent = this.props.currentCompany && this.props.currentCompany.accent_color ? this.props.currentCompany.accent_color : '#CD043A';
    const sortDirectionClass = this.state.ascending ? '' : 'down';
 
    return (
      <TableHeader 
        accent={ accent } 
        caretTypes={ caretTypes } 
        sortDirectionClass={sortDirectionClass}
        reportType={'attachment'}
        hasMultiSelect={false}
        hasMultiSelectFirst={true}
        handleMultiSelect={this.handleMultiSelect}
        item={location}
        multiSelectEnabled={this.state.selectedLocations ? !!this.state.selectedLocations[location.id] : false}
      />
    );
  }

  createTableContent(attachments) {
    // Create rows
    let isEvenRow = false;

    const { selectedAttachment } = this.state;
    const tableRows = attachments.map((attachment, index) => {
      isEvenRow = !isEvenRow;
      let selected = false;
      if (selectedAttachment && selectedAttachment.id == attachment.id) {
        selected = true;
      }
      return (
        <TableRow
          key={attachment.id}
          even={isEvenRow}
          selectedItem={attachment}
          type={'attachment'}
          hasNarrowCheckBox={true}
          checked={this.handleChecked}
          select={this.handleAttachmentSelected}
          rowSelected={selected}
          isSelected={this.state.selectedAttachments ? !!this.state.selectedAttachments[attachment.id] : false}
        />
      );
    });
    return <div className={'attachment-scroller'}>  
    <div className='attachment-rows' ref={(element) => {
      this.list = element;
    }}>
      {tableRows}
    </div>
  </div>;  

  }

  createLocationDocumentsList(location) {
    let viewing = this.props.viewing;
    const { progressReports } = this.props;
    let attachmentsHeader = this.createTableHeader(location);
    if (
      (viewing == DOCUMENTS && this.props.initialized &&
        (!location.documents || location.documents.length == 0)) ||
      (viewing == CLOSEOUT_HISTORY && (!location.all_closeouts || location.all_closeouts.length == 0)) ||
      (viewing == PROGRESS_REPORTS && (!progressReports || progressReports.length == 0))
    ) {
      let error;
      if (viewing == DOCUMENTS) {
        error = 'No Documents found.';
      }
      else if (viewing == CLOSEOUT_HISTORY) {
        error = 'No Closeouts found.';
      }
      else if (viewing == PROGRESS_REPORTS) {
        error = 'No Progress Reports found.';
      }
      const attachments = (
        <div className="empty-location-row" key={'empty-row-' + location.id}>
          {error}
        </div>
      );
      return <div className={'attachments-table'}>
      {attachmentsHeader}  
      {attachments}
    </div>;
    }
    else {
      const completionDocs = this.sortDocsAndSetFirstAttachment(location);
      const attachments = this.createTableContent(completionDocs);
      return <div className={'attachments-table'}>
          {attachmentsHeader}  
          {attachments}
      </div>;
    }
  }

  handleGoToLocation(location) {
    if (this.props.gotoLocation) {
      this.props.gotoLocation(location);
    }
  }

  createLocationsList() {
    const { locations, viewing, selectedLocationId, progressReports } = this.props;
    let locationAttachments = [];

    // Progress reports are project-level: show them even when there are no locations
    if (viewing === PROGRESS_REPORTS && progressReports && progressReports.length > 0 && (!locations || locations.length === 0)) {
      const virtualLocation = { id: 'project', name: '' };
      const locationDocuments = this.createLocationDocumentsList(virtualLocation);
      locationAttachments.push(
        <div className="locations-list" key="location-row-project">
          {locationDocuments}
        </div>
      );
      this.firstAttachment = null;
      return locationAttachments;
    }

    if (!locations) {
      return locationAttachments;
    }

    if (locations && locations.forEach) {
      locations.forEach(location => {
        if (selectedLocationId && selectedLocationId != location.id) {
        }
        else {
          let empty = null;
          if (
            (viewing == DOCUMENTS && (!location.documents || !location.documents.length)) ||
            (viewing == CLOSEOUT_HISTORY && (!location.all_closeouts || !location.all_closeouts.length)) ||
            (viewing == PROGRESS_REPORTS && (!progressReports || !progressReports.length))
          ) {
            empty = 'empty';
          }
          if (
            (viewing == DOCUMENTS && location.documents) ||
            (viewing == CLOSEOUT_HISTORY && location.all_closeouts) ||
            (viewing == PROGRESS_REPORTS && progressReports)
          ) {
            const locationDocuments = this.createLocationDocumentsList(location);
            locationAttachments.push(
              <div className={`locations-list ${empty}`} key={'location-row-' + location.id}>
                <LocationRow
                  location={location}
                  viewing={viewing}
                  gotoLocation={this.handleGoToLocation}
                />
                {locationDocuments}
              </div>
            );
          }
        }
      });
      this.firstAttachment = null;
    }
    return locationAttachments;
  }

  handleDownload() {
    this.setState({ attachmentsChecked: [], selectAll: {}, locationsChecked: [] });
    if (this.props.viewing == CLOSEOUT_HISTORY) {
      this.analyticsLogger.logCloseoutDocument('CloseoutDocumentDownloadedPOR');
    }
  }

  render() {
    const { attachmentsChecked } = this.state;
    let viewing = this.props.viewing;
    // TODO new component
    const locationAttachments = this.createLocationsList();
    let selected = [];
    if (attachmentsChecked && attachmentsChecked[viewing]) {
      for (let key in attachmentsChecked[viewing]) {
        if (key) {
          selected.push(key);
        }
      }
    }
    const emptyTitle =
      viewing === DOCUMENTS
        ? 'No Documents found.'
        : viewing === CLOSEOUT_HISTORY
          ? 'No Closeouts found.'
          : viewing === PROGRESS_REPORTS
            ? 'No Progress Reports found.'
            : 'No Documents found.';

    return (
      <div className="attachments-table--wrapper">
        {locationAttachments.length ? (
          <div className="attachments-table-interior">
            {locationAttachments}
          </div>
        ) : (
          <div className="attachments-table-interior--empty">
            <img src={scrollIcon} alt="document placeholder" />
            <p className="attachments-table-interior--empty--title">{emptyTitle}</p>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/PORContainer/PORLocationDocuments/AttachmentsTable/index.js